module.exports = __webpack_public_path__ + "static/media/c3.3eb0a1e6.jpg";